<template>
  <div class="mapping-container">
    <div class="tree-section">
      <h2>XML Tree</h2>
      <xmlTreeWrapper @shareNode="handleNodeSelection" />
    </div>
    <div class="mapping-section">
      <div class="mappingDownload" @click="downloadMapping"><span class="material-symbols-outlined mappingButton">download</span></div>
      <div class="mappingUpload">
      <label for="xml-upload" class="upload-button">
          <span class="material-symbols-outlined mappingButton">upload</span>
        </label>
        <input type="file" id="xml-upload" accept=".json" @change="uploadMapping" style="display: none;" />
      </div>
      <h2>Placeholder Mapping</h2>
      <div class="mapping-list">
        <div v-for="(mapping, index) in mappings" :key="index" class="mapping-item">
          <input 
           @click = "currentIndex = index, console.log(currentIndex)"
            type="text" 
            v-model="mapping.placeholder" 
            placeholder="Placeholder" 
          />
          <input 
            @click = "currentIndex = index, console.log(currentIndex)"
            type="text" 
            v-model="mapping.xpath" 
            placeholder="choose path" 
          />
          <div @click="removeMapping(index)" class="delete-button">
            <span class="material-symbols-outlined">delete</span>
          </div>
          <div @click="showXPathValue(index)" class="delete-button">
            <span class="material-symbols-outlined">visibility</span>
          </div>
          <XPathValueModal v-if="showValueModal && clickedIndex == index" :index = "index" @close="closeValueModal"/>
        </div>
      </div>
      <div class="add-button" @click="addMapping"><span class="material-symbols-outlined">add_circle</span></div>
    </div> 
  </div>
</template>

<script>
import xmlTreeWrapper from './Reusables/XTree/xmlTreeWrapper.vue'
import { mapActions, mapState } from 'vuex';
import XPathValueModal from './Reusables/XPathValueModal.vue'

export default {
  name: 'XmlMappingEditor',
  components: {
    xmlTreeWrapper,  XPathValueModal
  },
  data() {
    return {
      mappings: [], // Startet mit einem leeren Mapping
      currentIndex: null, // Hier wird der Index des aktuellen Mappings gespeichert
      selectedXPath: '', // Hier wird der aktuelle XPath gespeichert
      showValueModal: false,
      clickedIndex: null
    };
  },
  computed:{
    ...mapState(['xPathPlaceholders'])
  },
  methods: {
    ...mapActions(['updateXPathPlaceholders']), // Vuex-Action, um die Mappings zu speichern
    

    handleNodeSelection(node) {
      // Hier wird der vom Tree ausgewählte XPath in das aktuelle Mapping eingefügt
      if (this.mappings.length > 0 && this.currentIndex == null) {
        this.mappings[this.mappings.length - 1].xpath = node.xpath;
      } else {
        this.mappings[this.currentIndex].xpath = node.xpath;
      }
    },
    addMapping() {
      // Fügt ein neues Mapping-Feld hinzu
      this.currentIndex = null
      this.mappings.push({ placeholder: '', xpath: '' });
    },
    removeMapping(index) {
      // Entfernt ein Mapping aus der Liste
      this.mappings.splice(index, 1);
    },
    showXPathValue(index) {
      // Zeigt den Wert für das aktuelle Mapping an
      this.clickedIndex = index;
     this.showValueModal = true;
    },
    saveMappings() {
      // Speichert das Mapping im Vuex-Store
      this.updateXPathPlaceholders(this.mappings);
      console.log(this.mappings);
    },
    closeValueModal() {
      // Schließt das Value-Modal
      this.showValueModal = false;
    } ,
    async downloadMapping() {
      const emailTitle = this.emailTitle || 'NewTemplate';
      const mapping = this.xPathPlaceholders
      const jsonString = JSON.stringify(mapping, null, 2);
      console.log(jsonString)
      const a = document.createElement('a');
      const file = new Blob([jsonString], { type: 'application/json'});
      a.href = URL.createObjectURL(file);
      a.download = `${emailTitle}Mapping-${new Date().toLocaleDateString()}.json`;
      a.click();
    },
    async uploadMapping(event){
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
          try {
            const json = JSON.parse(e.target.result);
            this.updateXPathPlaceholders(json);
            this.mappings = this.xPathPlaceholders;
          } catch (error) {
            console.error('Invalid JSON file:', error);
          }
        };
        reader.readAsText(file);
    }
  },
  mounted() {
    this.mappings = this.xPathPlaceholders;
  },
  beforeUnmount(){
    this.saveMappings();
  }
}
</script>

<style scoped>
.mapping-container {
  display: flex;
  height: 100vh;
}

.tree-section {
  width: 40%; /* 40% für den XML Tree */
  border-right: 1px solid #ddd;
  padding: 20px;
}

.mapping-section {
  position: relative;
  width: 60%; /* 60% für das Mapping-Formular */
  padding: 20px;
}

.mapping-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mapping-item {
  display: flex;
  gap: 10px;
  align-items: center;
}

input[type="text"] {
  padding: 5px;
  font-size: 14px;
  width: 40%; /* Eingabefelder gleich breit */
  border: 2px solid #ccc;
  transition: border-color 0.3s;
}

input[type="text"]:focus {
  border-color: black !important;
}

.delete-button, .add-button {
  padding: 5px;
  background: white;
  color: black;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
}

.add-button {
  margin-top: 10px;
}

.delete-button:hover, .add-button:hover {
  background: #f1f1f1;
}

.mappingDownload{
  position: absolute;
  left: 10px;
  top: 10px;
  cursor: pointer;
}

.mappingUpload{
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.mappingButton{
  color: darkgray;
  font-size: 26px;
}

.mappingButton:hover{
  color: black;
}


</style>
 